import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 5;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'autorec-page',
      title: `Auto-Reconciliation Review <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'T3 Books has analyzed your bank statement and matched transactions automatically. Review the results here before finalizing.',
      attachTo: { element: '[data-tour="autorec-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'autorec-tabs',
      title: `Review Tabs <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Transactions are sorted into three categories: <strong>Auto-Matched</strong> were confidently paired with existing transactions. <strong>Needs Review</strong> have suggested matches that need your confirmation. <strong>Missing</strong> are on your statement but not in your books — you may need to create them.',
      attachTo: { element: '[data-tour="autorec-tabs"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'autorec-matched',
      title: `Auto-Matched <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'These transactions were automatically matched. Review them to ensure accuracy — you can override any match if the system got it wrong.',
      attachTo: { element: '[data-tour="autorec-matched"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'autorec-warnings',
      title: `Parsing Warnings <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'If the bank statement PDF had any extraction issues, warnings appear at the top. These are usually minor formatting issues — check that dates and amounts look correct.',
      attachTo: { element: '[data-tour="autorec-warnings"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'autorec-proceed',
      title: `Finalize <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Once you\'ve reviewed all tabs, click Proceed to finalize the reconciliation. This marks all confirmed matches as reconciled and creates any new transactions from the Missing tab.',
      attachTo: { element: '[data-tour="autorec-proceed"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'autoRecReview',
  pathPattern: new RegExp('^/banking/auto-reconciliation/.+/review'),
  getSteps,
  label: 'Auto-Reconciliation Review Tour',
});
